export const datatable = {
  colorScheme: {
    light: {
      // header: {
      //   background: '{primary.500}',
      //   color: 'black',
      //   borderColor: '{primary.400}',
      // },
      // headerCell: {
      //   color: '{text.color}',
      // },
      body: {
        //   background: 'red',
        // color: '#333',
        //   borderColor: '#5B5F69',
        //   cell: {
        //     background: 'red',
        //     color: '#aeb5b7',
        //     borderColor: '#5B5F69',
        //   },
        // },
        // row: {
        //   background: 'red',
        //   hoverBackground: '{primary.50}',
        //   borderColor: 'blue',
      },
      row: {
        // background: '#3C434F',
        color: '#333',
        // hoverBackground: '{primary.800}',
      },
    },
    dark: {
      header: {
        background: '#3C434F',
        color: '#aeb5b7',
        borderColor: '#5B5F69',
        cell: {
          background: '#3C434F',
          color: '#aeb5b7',
          borderColor: '#5B5F69',
          selected: {
            color: '#c9cecf', // Texto del filtro en blanco
          },
        },
      },
      headerCell: {
        color: '{text.color}',
        selectedBackground: '{primary.400}',
        hoverBackground: '{primary.300}',
        hoverColor: '{neutral.50}',
      },
      body: {
        background: '#3C434F',
        color: '#aeb5b7',
        borderColor: '#5B5F69',
        cell: {
          background: '#323743',
          color: '#aeb5b7',
          borderColor: '#5B5F69',
        },
      },
      row: {
        background: '#3C434F',
        color: '#aeb5b7',
        hoverBackground: '{primary.800}',
        borderColor: '#363c47',
        selected: {
          background: '#333842',
          color: '#c9cecf', // Texto del filtro en blanco
        },
      },
    },
  },
  css: ({ dt }: { dt: (key: string) => string }) => `
    .p-datatable {
      border-radius: 5px;
      overflow: hidden;
    }

    .p-datatable-header {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }

    .p-datatable-footer {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;

    }
  `,
};
